import { DateInt12 } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Partner } from './partner.model';
import { Profile } from './profile.model';
import { User } from './user.model';

export enum ReportStatus {
    Pending = 'pending',
    Handled = 'handled'
}

@CwtModel({ name: 'profile-report', path: '/profile-report' })
export class ProfileReport extends ApiData {
    reporter?: Profile;
    reported?: Profile;
    partner?: Partner;
    content?: string;
    status?: ReportStatus;

    fieldDictionary() {
        return {
            user: User
        };
    }
}
